
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"warning.objectNotShown.zoomOutsideOfScaleRange":"Unable to display. Layer not visible at current scale."},"de":{"warning.objectNotShown.zoomOutsideOfScaleRange":"Anzeige nicht möglich. Layer im aktuellen Maßstab nicht sichtbar."}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();